import {
  GET_SPORTS_REQUEST,
  GET_SPORTS_SUCCESS,
  GET_SPORTS_FAILURE,
  GET_SPORT_BY_ID_REQUEST,
  GET_SPORT_BY_ID_SUCCESS,
  GET_SPORT_BY_ID_FAILURE,
  ADD_SPORT_REQUEST,
  ADD_SPORT_SUCCESS,
  ADD_SPORT_FAILURE,
  UPDATE_SPORT_REQUEST,
  UPDATE_SPORT_SUCCESS,
  UPDATE_SPORT_FAILURE,
  DELETE_SPORT_REQUEST,
  DELETE_SPORT_SUCCESS,
  DELETE_SPORT_FAILURE,
  SEARCH_SPORTS_REQUEST,
  SEARCH_SPORTS_SUCCESS,
  SEARCH_SPORTS_FAILURE,
} from "../actions/actionsCreators";

const initialState = {
  SportData: null,
  SportDetails: null,
  isLoading: false,
  error: null,
};

const sportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SPORTS_REQUEST:
    case GET_SPORT_BY_ID_REQUEST:
    case ADD_SPORT_REQUEST:
    case UPDATE_SPORT_REQUEST:
    case DELETE_SPORT_REQUEST:
    case SEARCH_SPORTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case GET_SPORTS_SUCCESS:
    case SEARCH_SPORTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        SportData: action.payload,
        error: null,
      };

    case GET_SPORT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        SportDetails: action.payload,
        error: null,
      };

    case ADD_SPORT_SUCCESS:
    case UPDATE_SPORT_SUCCESS:
    case DELETE_SPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case GET_SPORTS_FAILURE:
    case GET_SPORT_BY_ID_FAILURE:
    case ADD_SPORT_FAILURE:
    case UPDATE_SPORT_FAILURE:
    case DELETE_SPORT_FAILURE:
    case SEARCH_SPORTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default sportReducer;
